module.exports = __webpack_public_path__ + "img/index-partners-banner-3.3cb66c89.jpg";